//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.adapter

import blazern.lexisoup.graphql.model.SuggestionsQuery
import blazern.lexisoup.graphql.model.fragment.SentenceFieldsImpl_ResponseAdapter
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.obj
import kotlin.String
import kotlin.collections.List

public object SuggestionsQuery_ResponseAdapter {
  public object Data : Adapter<SuggestionsQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("suggestions")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): SuggestionsQuery.Data {
      var _suggestions: List<SuggestionsQuery.Suggestion>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _suggestions = Suggestion.obj().list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return SuggestionsQuery.Data(
        suggestions = _suggestions ?: missingField(reader, "suggestions")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: SuggestionsQuery.Data,
    ) {
      writer.name("suggestions")
      Suggestion.obj().list().toJson(writer, customScalarAdapters, value.suggestions)
    }
  }

  public object Suggestion : Adapter<SuggestionsQuery.Suggestion> {
    public val RESPONSE_NAMES: List<String> =
        listOf("__typename", "text", "langIso3", "source", "translations")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): SuggestionsQuery.Suggestion {
      var __typename: String? = null
      var _text: String? = null
      var _langIso3: String? = null
      var _source: String? = null
      var _translations: List<SuggestionsQuery.Translation>? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          1 -> _text = StringAdapter.fromJson(reader, customScalarAdapters)
          2 -> _langIso3 = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _source = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _translations = Translation.obj(true).list().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return SuggestionsQuery.Suggestion(
        __typename = __typename ?: missingField(reader, "__typename"),
        text = _text ?: missingField(reader, "text"),
        langIso3 = _langIso3 ?: missingField(reader, "langIso3"),
        source = _source ?: missingField(reader, "source"),
        translations = _translations ?: missingField(reader, "translations")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: SuggestionsQuery.Suggestion,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      writer.name("text")
      StringAdapter.toJson(writer, customScalarAdapters, value.text)

      writer.name("langIso3")
      StringAdapter.toJson(writer, customScalarAdapters, value.langIso3)

      writer.name("source")
      StringAdapter.toJson(writer, customScalarAdapters, value.source)

      writer.name("translations")
      Translation.obj(true).list().toJson(writer, customScalarAdapters, value.translations)
    }
  }

  public object Translation : Adapter<SuggestionsQuery.Translation> {
    public val RESPONSE_NAMES: List<String> = listOf("__typename")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): SuggestionsQuery.Translation {
      var __typename: String? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> __typename = StringAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      reader.rewind()
      val _sentenceFields = blazern.lexisoup.graphql.model.fragment.SentenceFieldsImpl_ResponseAdapter.SentenceFields.fromJson(reader, customScalarAdapters)

      return SuggestionsQuery.Translation(
        __typename = __typename ?: missingField(reader, "__typename"),
        sentenceFields = _sentenceFields
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: SuggestionsQuery.Translation,
    ) {
      writer.name("__typename")
      StringAdapter.toJson(writer, customScalarAdapters, value.__typename)

      SentenceFieldsImpl_ResponseAdapter.SentenceFields.toJson(writer, customScalarAdapters, value.sentenceFields)
    }
  }
}
